import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface TestData {
  message: string
}

@Component({
  selector: 'neq-rgpd-popin',
  templateUrl: './rgpd-popin.component.html',
})
export class NeqRgpdPopinComponent implements OnInit {

  @ViewChild('termsAcceptance') termsAcceptanceCheckbox: ElementRef;
  @ViewChild('termsAcceptanceError') termsAcceptanceError: ElementRef;
  @ViewChild('personalDataAcceptance') personalDataAcceptanceCheckbox: ElementRef;

  messageHeader: string;
  messageCheckboxTerms: string;
  messageErrorTerms: string;
  messageCheckboxPersonalData: string;

  constructor(
    private readonly dialogRef: MatDialogRef<NeqRgpdPopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TestData
  ) {}

  ngOnInit() {
    if (this.data?.message) {
      this.messageHeader = this.data.message.split('\n')[0];
      this.messageCheckboxTerms = this.data.message.split('\n')[1];
      this.messageErrorTerms = this.data.message.split('\n')[2];
      this.messageCheckboxPersonalData = this.data.message.split('\n')[3];
    }
  }

  continue() {
    if (this.termsAcceptanceCheckbox.nativeElement.checked) {
      this.dialogRef.close(this.personalDataAcceptanceCheckbox.nativeElement.checked);
    } else {
      this.termsAcceptanceError.nativeElement.hidden = false;
    }
  }

  goBack() {
    this.dialogRef.close(null);
  }
}
